<template>
    <div class="featureGridComponent">
        <div class="featureGrid"
            v-bind:style="featureGridStyles">
            <div v-for="(cellDef) in getCellDefs(this.gridDef)"
                :class="featureGridCellClasses(cellDef)"
                v-bind:style="calcGridCellStyles(cellDef)">
                <div class="numId" v-if="showSlideNumbers">{{cellDef.imageNum + 1}}</div>
                <cropzoomImg
                    ref="imgs"
                    :key="cellDefSlide(cellDef).title"
                    :src="cellDefSlide(cellDef).imageUrl"
                    :alt="cellDefSlide(cellDef).title"
                    :title="cellDefSlide(cellDef).title"
                    :aspect-ratio="calcRealAspectRatio(cellDef)"
                    :data="cellDefSlide(cellDef)"
                    :click-callback="handleClick"/>
            </div>
        </div>
        <div class="gridlayout-hasMoreUrl" v-if="hasMore" ref="viewmore">
            <a class="btn btn-primary btn-primary-ghost" v-on:click="viewMore" >View More</a>
        </div>
    </div>
</template>

<script>
import cropzoomImg from "./cropzoomImg.vue";
import pickGridTemplate from "./gridLayouts/layoutLibrary.js";


const DEBUG  = false;
const DEBUG2 = false;

export default {
    name: 'gridlayout',
    props: {
        options: Object,
        aspectRatio: Number,
        clickCallback: {
            type: Function,
            default: null,
        }
    },
    components: {
        cropzoomImg,
    },
    data: function () {
        const showSlideNumbers =
                window.location.pathname.match(/show-slide-numbers/) ?
                true : false;

        return {
            fixedNumColumns: false,
            fullWidth: null,
            fullHeight: null,
            gridDef: null,
            showMax: 0,
            showSlideNumbers: showSlideNumbers,
            //slidesShown: [],
        };
    },
    computed: {
        borderWidth: function () {
            return this.gridDef.borderWidth ? this.gridDef.borderWidth: 20;
        },
        cellStyles: function () {
            const widthPercent = 100/this.numColumns;
            return {
                width: `${widthPercent}%`,
            }
        },
        extraRows: function () {
            return this.gridDef.extraRows;
        },
        featureGridStyles: function () {
            const height = `${this.fullHeight}px`;
            return {
                height: height,
            }
        },
        hasMore: function () {
            return this.showMax < this.options.slides.length;
        },
        numSlides: function () {
            return this.options.slides.length;
        },
        numberOfColumns: function () {
            return this.gridDef.numColumns;
        },
        numberOfRows:  function () {
            const slides = this.$props.options.slides;
            const num = slides.length;
            let numRows = Math.ceil(num/this.numColumns);
            if (DEBUG) console.log("gl61: numrows", {
                num, numRows, numColumns: this.numColumns
            })
            return numRows;
        },
    },
    methods: {
        calcNumColumns: function () {
            const numCols = this.gridDef.numColumns;
            return numCols;
        },

        calcGridCellSizes: function (cellDef) {
            // position
            const topOffset = this.borderWidth * (cellDef.row+1);
            let leftOffset = this.borderWidth * (cellDef.col+1);
            if (this.centeringOffset) {
                leftOffset = leftOffset + this.centeringOffset;
            }
            const top = (cellDef.row * this.cellHeight) + topOffset;
            const left = (cellDef.col * this.cellWidth) + leftOffset;
            const sizeX = cellDef.sizeX
                            ? cellDef.sizeX
                            : (cellDef.size ? cellDef.size : 1);
            const sizeY = cellDef.sizeY
                            ? cellDef.sizeY
                            : (cellDef.size ? cellDef.size : 1);
            if (false) console.log("fg115: sizeX, sizeY", sizeX, sizeY);
            const width = sizeX * this.cellWidth
                            + (sizeX-1) * this.borderWidth;
            const height = sizeY * this.cellHeight
                            + (sizeY-1) * this.borderWidth;

            const aspectRatio = width/height;
            return {
                top: top,
                left: left,
                width: width,
                height: height,
                topOffset,
                leftOffset,
                aspectRatio,
            }
        },
        calcGridCellStyles: function (cellDef) {
            const sizes = this.calcGridCellSizes(cellDef);
            return {
                top:   `${sizes.top}px`,
                left:  `${sizes.left}px`,
                width: `${sizes.width}px`,
                height: `${sizes.height}px`,
            }
        },
        calcRealAspectRatio: function (cellDef) {
            // when featured images span borders real aspect ratio changes
            const sizes = this.calcGridCellSizes(cellDef);
            return sizes.aspectRatio;
        },
        cellDefSlide: function (cellDef) {
            return cellDef.imageNum;
        },
        displaying: function (cellDef) {
            this.slidesShown.push(cellDef.imageNum);
            this.numShown = this.slidesShown.length;
            return cellDef.imageNum;
        },
        featureGridCellClasses: function (cellDef) {
            const classes = `featureGridCell ${cellDef.fullClass}`;
            return classes;
        },
        getMediaType: function () {
            const isXS = window.matchMedia("(max-width: 767px)").matches;
            const isMD = window.matchMedia("(min-width: 768px) and (max-width: 991px)").matches;
            const isLG = window.matchMedia("(min-width: 992px) and (max-width: 1199px)").matches;
            const isGiant = window.matchMedia("(min-width: 1200px)").matches;
            if (isXS) { return "xs";}
            else if (isMD) { return "md";}
            else if (isLG) { return "lg";}
            else /* if (isGiant) */ { return "desktop"};
        },
        getRightGridDef: function () {
            // note the griddef is partially defined in the template
            // form and partially built after.

            let useGrid = null;
            /* note: this commented out code can get an "alternate grid"
               to use from the path.  Names have to appear in the
               layoutLibrary. Just for testing */
            // const useGridMatch = window.location.pathname.match(/altGrid-(.*)/);
            // useGrid = useGridMatch ? useGridMatch[1] : null;
            // console.log("fg174:", useGrid, useGridMatch);

            let gridDefTemplate = pickGridTemplate({
                mediaType: this.getMediaType(),
                slides: this.options.slides,
                useGrid: useGrid,
            });

            const gridDef = this.buildGridDef(gridDefTemplate);
            this.gridDef = gridDef;
            if (this.showMax < gridDef.slidesCovered) {
                this.showMax = gridDef.slidesCovered;
            }
            //console.log("fg193: gridDef", gridDef);
            return this.gridDef;
        },
        handleClick: function (event, data) {
            if (DEBUG2) console.log("fg106: feature grid handleClick", event, data);
            if (this.$props.clickCallback) {
                this.$props.clickCallback(event, data);
            }
        },
        handleCurrentSize: function () {
            if (DEBUG) console.log("fg112: handleCurrentSize")
            // select correct gridDef
            this.gridDef = this.getRightGridDef(this.options.slides);
            this.numColumns = this.gridDef.numColumns;
            this.numRows = this.gridDef.numRows;
            this.fullWidth = this.$el.clientWidth;
            this.centeringOffSet = 0;
            if (this.gridDef.maxWidth && (this.fullWidth > this.gridDef.maxWidth)) {
                console.log("fg205:", {  maxWidth: this.gridDef.maxWidth,
                                        fullWidth: this.fullWidth,
                                    });
                this.centeringOffset = Math.ceil((this.fullWidth - this.gridDef.maxWidth)/2);
                this.fullWidth = this.gridDef.maxWidth;
            }
            const widthNoBorder = this.fullWidth
                                    - (this.borderWidth*(this.numColumns+1));
            this.cellWidth = Math.floor(widthNoBorder / this.numColumns);
            this.cellHeight = Math.floor(this.cellWidth / this.aspectRatio);
            //const totalRows = this.numRows + this.extraRows;
            const totalRows = this.gridDef.usedRows + this.extraRows;
            if (DEBUG2) console.log("fg209:", totalRows, this.gridDef.usedRows, this.extraRows);
            this.fullHeight = this.cellHeight * (totalRows)
                                + (this.borderWidth*(totalRows+1));
            this.clientHeight = this.$el.clientHeight;


            if (DEBUG2) {
                console.log("wide, cellwide", {
                    fullWidth: this.fullWidth,
                    fullHeight: this.fullHeight,
                    cellWidth: this.cellWidth,
                    cellHeight: this.cellHeight,
                });
            }
            if (this.$refs.imgs) {
                for (let img of this.$refs.imgs) {
                    img.handleCurrentSize();
                }
            }
            this.$nextTick(() => this.$forceUpdate());
        },
        row: function (rowIndex) {
            throw Error("deprecated");
            const slideStart = rowIndex*this.numColumns;
            const slideEnd   = slideStart + this.numColumns;

            return this.$props.options.slides.slice(slideStart, slideEnd);
        },
        cellDefSlide: function (cellDef) {
            return this.options.slides[cellDef.imageNum];
        },
        getCellDefs: function (gridDef) {
            //const generateCellInstances = this.generateCellInstances(gridDef);
            if (!gridDef) {
                return [];
            }
            return this.gridDef.cellInstances;
        },
        buildGridDef: function (gridDef) {
            if (!gridDef) {
                // don't have gridDef yet
                console.log("Warning: called buildGridDef with no gridDef")
                return null;
            }
            if (DEBUG2) console.log("fg213: building", gridDef);
            let slides = this.options.slides;
            let goodCellDefs = [];
            let usedRows = 0; // keep  track of rows actually used
            for (let cellDefIndex in gridDef.cells) {
                const cellDef = gridDef.cells[cellDefIndex];
                // fill defaults if needed
                if (!cellDef.size) {
                    cellDef.size = 1;
                }

                const cellYSize = cellDef.sizeY ?  cellDef.sizeY : cellDef.size;

                // adding cells
                if (cellDef.imageNum < slides.length) {
                    let itemclass =  `item-${cellDef.imageNum+1}`;
                    if (cellDef.class) {
                        itemclass = `${cellDef.class} ${itemclass}`;
                    }
                    cellDef.fullClass = itemclass;
                    usedRows = Math.max(usedRows, cellDef.row+cellYSize);
                    goodCellDefs.push(cellDef);
                }
            }
            if (DEBUG2) console.log("usedRows", usedRows);
            gridDef.usedRows = usedRows; // used from the basic


            // extras, all size 1, based on gridDev rows;
            const startSlide = gridDef.slidesCovered;
            if (DEBUG2) console.log("startSlide", startSlide, typeof(startSlide));
            if (slides.length > startSlide) {
                const endp = Math.min(slides.length, this.showMax)
                const moreSlides = slides.slice(startSlide, endp);
                if (DEBUG2) console.log("startSlide, endp",
                                            {startSlide, endp, showMax: this.showMax,
                                            moreSlidesLength: moreSlides.length});
                const numRows = gridDef.numRows;
                const numCols = gridDef.numColumns;
                let extraRows = 0;
                let row = numRows;
                let col=0;
                for (let index=0; index < moreSlides.length; index++) {
                    //console.log("fg220: add extra", index+startSlide, col, row);
                    goodCellDefs.push( {
                        imageNum: index+startSlide,
                        row: row,
                        col: col,
                        size: 1,
                        class: `item-${index+startSlide}`,
                    });
                    extraRows = Math.max(row-numRows+1, extraRows);
                    col++;
                    if (col >= numCols) {
                        col = 0;
                        row++;
                    }
                }
                if (DEBUG2) console.log("fg246: extraRows", extraRows);
                gridDef.extraRows = extraRows;
            }
            gridDef.cellInstances = goodCellDefs;
            // note: though I return this, it's also modified in place.
            // caller should clone if nec.
            return gridDef;
        },
        viewMore: function (event) {
            if (DEBUG) console.log(
                "fg277: showMax was", this.$props.options.moduleId,
                this.showMax);
            this.showMax += this.gridDef.moreSize;
            if (DEBUG) console.log("fg279: showMax now is", this.showMax);
            // do size calculations, though atm only .featureGrid needs
            // to change height.
            this.handleCurrentSize();

            setTimeout ( () => {
                if (this.hasMore) {
                    const viewmore = this.$refs.viewmore;
                    if (viewmore) {
                        viewmore.scrollIntoView(false);
                    }
                } else {
                   const imgs = this.$refs.imgs;
                    if (imgs) {
                        const lastimg = imgs[imgs.length-1];
                        lastimg.$el.scrollIntoView(false);
                    }
                }
            }, 250);
        },

    },
    // li
    created: function () {
        window.addEventListener('resize', () => this.handleCurrentSize());
    },
    mounted: function () {
        //this.$nextTick( () => this.handleCurrentSize() );
        if (DEBUG) console.log("gl132: props options", this.$props.options );
        this.handleCurrentSize();
        this.$nextTick( () => this.$forceUpdate());
    }
};
</script>

<style lang="scss">
.numId {
    position: absolute;
    top: 5px;
    left: 5px;
    z-index: 7000;
    background-color: rgba(255,255,255,.5);
    color: black;
    padding: 3px;
}
.featureGrid {
    background: none;
    width: 100%;
    padding: 15px 0 15px;
    position:relative;
}
.featureGridCell {
    position: absolute;

}
.gridlayout-row {
    line-height: 0; // gets rid of little space at bottom
    margin: 0 -15px;
    // border: dashed black 1px;
}
.gridlayout-cell {
    display: inline-block;
    overflow: hidden;
    padding: 15px;

    .cropzoomimg-container {
        max-width: 1200px
    }
}
.gridlayout-hasMoreUrl {
    margin: 2rem 0 2rem;
    text-align: center;
    width: 100%;
}
</style>
